import { type FireAnalyticsEvent } from '../../types';

export const onInvalidIdentifiers = ({
	searchSessionId,
}: {
	searchSessionId?: string;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: 'NO_IDENTIFIER',
			searchSessionId,
		},
	},
});
